import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MyPackageDetailsComponent } from "./my-package-details.component";
import { PipesModule } from "../pipes/pipes.module";
import { ServiceIncludedModule } from "../service-included/service-included.module";
import { DirectiveModule } from "../directive/directive.module";
import { ConsultationTypeModalModule } from "../consultation-type-modal/consultation-type-modal.module";
import { HealthPackageFlowModule } from "../health-package-flow/health-package-flow.module";

@NgModule({
  declarations: [MyPackageDetailsComponent],
  imports: [CommonModule, PipesModule, ServiceIncludedModule, ConsultationTypeModalModule, HealthPackageFlowModule],
  exports: [MyPackageDetailsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MyPackageDetailsModule {}
